import React, { createContext, useContext, useState, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../../services/Api';
import { useAlert } from '../../geral/AlertContext';
import { useMessage } from '../../geral/MessageContext';

const ApresentacaoConjuntoContext = createContext();

export const useApresentacaoConjunto = () => useContext(ApresentacaoConjuntoContext);

export const ApresentacaoConjuntoProvider = ({ children }) => {
    const [apresentacaoConjuntos, setApresentacaoConjuntos] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchApresentacaoConjuntos = useCallback(async (apresentacaoId) => {
        if (!apresentacaoId) {
            setApresentacaoConjuntos([]);
            return;
        }

        try {
            const result = await fetchData(`/ApresentacaoConjunto/GetByApresentacaoId?apresentacaoId=${apresentacaoId}`);
            
            setApresentacaoConjuntos(result);
        } catch (error) {
            console.error("Erro ao buscar apresentações do conjunto:", error);
            showMessage(`Erro ao buscar apresentações do conjunto! ${error?.message || error}`, 'danger');
        }
    }, [showMessage]);

    // useEffect(() => {
    //     fetchApresentacaoConjuntos();
    // }, [fetchApresentacaoConjuntos]);

    const addApresentacaoConjunto = async (item) => {
        try {
            const result = await postData('/ApresentacaoConjunto', item);
            setApresentacaoConjuntos([...apresentacaoConjuntos, result]);
            showAlert('Apresentação do conjunto adicionada com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar apresentação do conjunto:", error);
            showMessage('Erro ao adicionar apresentação do conjunto!\n' + error, 'danger');
        }
    };

    const updateApresentacaoConjunto = async (item) => {
        try {
            const result = await putData('/ApresentacaoConjunto', item);
            setApresentacaoConjuntos((prev) =>
                prev.map((i) => (i.id === result.id ? result : i))
            );
            showAlert('Apresentação do conjunto alterada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar apresentação do conjunto:", error);
            showAlert('Erro ao alterar apresentação do conjunto!', 'danger');
        }
    };

    const deleteApresentacaoConjunto = async (id) => {
        try {
            await deleteData('/ApresentacaoConjunto', { id });
            setApresentacaoConjuntos(apresentacaoConjuntos.filter(i => i.id !== id));
            showAlert('Apresentação do conjunto excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir apresentação do conjunto:", error);
            showAlert('Erro ao excluir apresentação do conjunto!', 'danger');
        }
    };

    return (
        <ApresentacaoConjuntoContext.Provider value={{
            apresentacaoConjuntos,
            addApresentacaoConjunto,
            updateApresentacaoConjunto,
            deleteApresentacaoConjunto,
            fetchApresentacaoConjuntos
        }}>
            {children}
        </ApresentacaoConjuntoContext.Provider>
    );
};
